import { CyberInsuranceMetadata, MainReportOption, RecurringReportConfig, ReportMenuOption, ReportType } from './types';
import { FREQUENCY_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';

export const REPORT_OPTIONS: Record<string, MainReportOption> = {
    [ReportMenuOption.RiskReport]: {
        id: ReportMenuOption.RiskReport,
        label: 'Risk Report',
        subItems: {
            [ReportMenuOption.SingleRiskReport]: {
                label: 'Generate Report',
                id: ReportMenuOption.SingleRiskReport,
                type: ReportType.RiskReport,
                isRecurring: false
            },
            [ReportMenuOption.RecurringRiskReports]: {
                label: 'Recurring Reports',
                id: ReportMenuOption.RecurringRiskReports,
                type: ReportType.RiskReport,
                isRecurring: true
            }
        }
    },
    [ReportMenuOption.CyberInsurance]: {
        id: ReportMenuOption.CyberInsurance,
        label: 'Cyber Insurance',
        subItems: {
            [ReportMenuOption.SingleCyberInsurance]: {
                id: ReportMenuOption.SingleCyberInsurance,
                label: 'Generate Report',
                type: ReportType.CyberInsurance,
                isRecurring: false
            }
        }
    }
};

export const DEFAULT_CYBER_INSURANCE_METADATA: CyberInsuranceMetadata = {
    emailPolicies: { selected: false, policies: [], selectedPolicies: [] },
    vpnPolicies: { selected: false, policies: [], selectedPolicies: [] },
    oldPassword: { selected: false, value: 3 },
    customControls: [],
    useCustomerIcon: false
};

export const DEFAULT_RECURRING_REPORT_CONFIG: RecurringReportConfig = {
    assessment_period: 30,
    frequency: FREQUENCY_OPTIONS.DAILY.value,
    recipients: [],
    type: ReportType.RiskReport,
    metadata: {
        modules: [],
        environment: 'onPrem'
    },
    is_active: false,
    hour: null,
    timezone: null,
    day_of_week: null,
    day_of_month: null
};
